import { Link } from "react-router-dom";
import TaxonomyChips from "../../../../Components/TaxonomyChips/TaxonomyChips";
import { useTranslation } from "../../../../i18n/LanguageProvider";
import Title from "../Title/Title";
import "./HomeBrowse.sass";

const HOME_PLACES_LIMIT = 12;

/**
 * Entry points to the category and country pages, so every profile is a few clicks from the home page.
 */
function HomeBrowse({ directory }) {
    const { t, localizedPath } = useTranslation();
    const categories = directory?.categories || [];
    const places = directory?.places || [];

    if (categories.length === 0 && places.length === 0) {
        return null;
    }

    return (
        <section className="home-browse" aria-labelledby="home-browse-title">
            <Title id="home-browse-title" text={t("home.browseCategories")} />
            <TaxonomyChips type="category" items={categories} />
            {places.length > 0 && (
                <>
                    <h3 className="home-browse__subtitle">{t("home.browsePlaces")}</h3>
                    <TaxonomyChips type="place" items={places} limit={HOME_PLACES_LIMIT} />
                </>
            )}
            <div className="home-browse__more">
                <Link to={localizedPath("/femei")}>{t("home.browseAll")}</Link>
            </div>
        </section>
    );
}

export default HomeBrowse;
